import type { GiftCard } from '../GiftCards.types'
import { useFilterGiftCards } from '../modules/GiftCardsFilter'
import { useGiftCardsInfiniteQuery } from '../queries/useGiftCardsInfiniteQuery'

export const useGiftCardsInfinite = () => {
  const { filtersParams } = useFilterGiftCards()
  const { query: giftCardsQuery } = useGiftCardsInfiniteQuery(
    {
      // @ts-ignore
      status: filtersParams.status as GiftCard['status'][] | undefined,
    },
    {
      keepPreviousData: true,
    },
  )

  const data = giftCardsQuery.data?.pages.flatMap((page) => page.result) || []
  const hasNextPage = Boolean(giftCardsQuery.hasNextPage)
  const fetchNextPage = giftCardsQuery.fetchNextPage

  return {
    data,
    isLoading: giftCardsQuery.isFetching,
    hasNextPage,
    onLoadMore: fetchNextPage,
  }
}
